import React, { useState } from 'react';

import { footerTexts, footerDesaffiliationTexts } from '../../../utils/constants';
import DynamicIcon from '../../atoms/DynamicIcon';

const PreFooter = () => {
  const [viewMore, setViewMore] = useState(false);
  return (
    <div className="prefooter">
      <div className={`footer-info ${viewMore ? 'active' : ''}`}>
        <h2 className="footer-info__title">{footerDesaffiliationTexts.title}</h2>
        <p className="footer-info__subtitle" dangerouslySetInnerHTML={{ __html: footerDesaffiliationTexts.subtitle }} />
        <h2 className="footer-info__title">{footerTexts.title}</h2>
        <p className="footer-info__subtitle">
          {footerTexts.subtitle}
        </p>
        <h2 className="footer-info__title">{footerTexts.secondTitle}</h2>
        <p className="footer-info__subtitle">
          {footerTexts.secondSubtitle}
        </p>
        <div className="contact">
          {footerTexts.infoContact.map((info) => (
            <div className="contact__link">
              <DynamicIcon icon={info.icon} />
              <a href={info.href}>{info.description}</a>
            </div>
          ))}
        </div>
      </div>
      <div
        className={`footer-info__viewmore ${viewMore ? 'active' : ''}`}
        onClick={() => setViewMore(!viewMore)}
      >
        <span className={`footer-info__viewmore__text ${viewMore && 'active'}`}>
          {`${!viewMore ? 'Ver más' : 'Ver menos'}`}
        </span>
      </div>
    </div>
  );
};

export default PreFooter;
